var _filter, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTail = function SvgTail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.3 24.8"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "tail_svg__a",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    slope: 0.1,
    type: "linear"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tail_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 15.7-.6-.5c-4.1-3.1-6.6-8-6.6-13.2V1h-1v9.5c0 3.5-2.3 6.7-5.7 8l-2.5 1H0v5.3h24.3v-7.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.1 18.5c3.3-1.3 5.7-4.5 5.7-8V1h1v1c0 5.3 2.5 10.1 6.6 13.2l.6.5-.7.4c-3.9 2.2-8.4 3.4-13.1 3.4H5.5c.1 0 2.6-1 2.6-1",
    clipPath: "url(#tail_svg__b)",
    style: {
      filter: "url(#tail_svg__a)"
    }
  }));
};
export default SvgTail;